/*  js-cart-notification 0.1 */

function absoluteStorefrontUrl(value, storefrontOrigin) {
  if (!value) return "";

  try {
    return new URL(value, storefrontOrigin).href;
  } catch (error) {
    return value;
  }
}

function buildKlaviyoAddedToCartPayload(response, requestedVariantId, requestedQuantity, productContext, storefrontOrigin) {
  const responseItems = response && Array.isArray(response.items)
    ? response.items
    : (response && (response.variant_id || response.id) ? [response] : []);
  const addedItem = responseItems.find(function (item) {
    const variantId = item && (item.variant_id || item.id);
    return String(variantId) === String(requestedVariantId);
  });

  if (!addedItem) return null;

  const unitPriceCents = Number(
    addedItem.final_price != null ? addedItem.final_price : addedItem.price
  );
  if (!Number.isFinite(unitPriceCents)) return null;

  // cart/add.js can report the cart line's accumulated quantity when the same
  // variant was already present; the event must represent only this add action.
  const parsedQuantity = Number(requestedQuantity || addedItem.quantity || 1);
  const quantity = Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;
  const context = productContext || {};
  const variantId = addedItem.variant_id || addedItem.id;
  const productUrl = absoluteStorefrontUrl(addedItem.url || context.URL, storefrontOrigin);
  const imageUrl = absoluteStorefrontUrl(addedItem.image || context.ImageURL, storefrontOrigin);

  return {
    ProductName: addedItem.product_title || context.ProductName || "",
    ProductID: addedItem.product_id || context.ProductID || "",
    VariantID: variantId,
    SKU: addedItem.sku || "",
    VariantTitle: addedItem.variant_title || "",
    Categories: context.Categories || [],
    ImageURL: imageUrl,
    URL: productUrl,
    Price: unitPriceCents / 100,
    Quantity: quantity,
    Currency: context.Currency || "",
    $value: (unitPriceCents * quantity) / 100
  };
}

function trackKlaviyoAddedToCart(response, requestedVariantId, requestedQuantity) {
  const payload = buildKlaviyoAddedToCartPayload(
    response,
    requestedVariantId,
    requestedQuantity,
    window.marlotKlaviyoProductContext,
    window.location.origin
  );

  if (!payload) return;

  window._learnq = window._learnq || [];
  window._learnq.push(["track", "Added to Cart", payload]);
}

function decodeCartErrorMessage(value) {
  return String(value || "")
    .replace(/&#0*39;|&#x0*27;|&apos;/gi, "'")
    .replace(/&quot;|&#0*34;|&#x0*22;/gi, '"')
    .replace(/&amp;/gi, "&");
}

function getCartAddErrorMessage(errorResponse, fallbackMessage) {
  const response = errorResponse && errorResponse.responseJSON;
  const responseMessage = response && (
    typeof response.description === "string" ? response.description : response.message
  );

  if (typeof responseMessage === "string" && responseMessage.trim()) {
    return decodeCartErrorMessage(responseMessage);
  }
  return decodeCartErrorMessage(
    fallbackMessage || "There was an error while updating your cart. Please try again."
  );
}

/*----------------------
   CART NOTIFICATION
---------------------- */
CartNotification = {
    init: function () {
      // close cart notification
      $(".button-close-cart").click(function () {
        $(".cart-notification").removeClass("cart-notification-active");
      });
      $("body").on("click", function(e){
        if (!$(e.target).closest('.button-add-cart, .cart-notification').length) {
          $(".cart-notification").removeClass("cart-notification-active");
        }
    })
  
      // handle quantity change
      $("[name='quantity']").on("change", function(e) {
        let qty = $(this).val();
        let priceEl = $("[name='price']");
        let price = $(priceEl).attr("data-price");
        $(priceEl).html(formatMoney(price * qty));
      });
  
      // ADD TO CART button from product page
      $(".button-add-cart").click(function () {
        const productID = $(this).attr('data-id');
        let productQty = $('#product_data').find('input[name="quantity"]').val();
        const randomID = Math.random() * 1e17;
        if (!productQty) productQty = 1;      
        if (productQty <= 0) return;
  
        $(this).addClass("product-adding");
  
        // look for all the product addons
        let items = [];
        let addonsEl = $('#product_data').find('[name="product_addon"]');
  
        // parse all the addons
        $(addonsEl).each(function(index) {
          let price = $(this).find('[name="price"]').attr("data-price");
          let id = $(this).attr("data-id");
          let qty = $(this).find('[name="quantity"]').val();
          let propName = $(this).find('[name="property"]').attr("data-name");
          let propValue = $(this).find('[name="property"]').attr("data-value");
          let properties = { '_link': randomID };
          if (propName) properties[propName] = propValue;
          
          if(qty > 0) {
            items.push({
              'id': Number(id), 'quantity': Number(qty),
              properties
            });
          }
        });
  
        // check if we must also add extra properties
        let addpropsEl = $('#product_data').find('[name="product_property"]');
  
        // parse all the addons
        properties = {};
        $(addpropsEl).each(function (index) {
          let propName = $(this).attr("data-name");
          let propValue = $(this).attr("data-value");
          if (propName) properties[propName] = propValue;
        });
  
        // if this item has addons, add the master link id
        if (items.length) properties['_mlink'] = randomID;
  
        //console.log(properties);
        
        // add the product to the array     
        items.push({ 'id': Number(productID), 'quantity': Number(productQty), ...(properties ? { properties } : {}) });      
  
        let json = { 'items': items, 'sections': 'section-cart-notification' };
        
        // make rest call to shopify      
        $.post(window.Shopify.routes.root + 'cart/add.js', json, null, "json")
          .done(function (data) {
            addToCart(data);
            $(".cart-notification").addClass("cart-notification-active");
            trackKlaviyoAddedToCart(data, productID, productQty);
          })
          .fail(function (data) {
            alert(getCartAddErrorMessage(data, window.marlotCartErrorMessage));
          })
          .always(function (data) {
            $(".button-add-cart").removeClass("product-adding");
            
          });
      });
  
  
  
      // ADD TO CART NOTIFICATION
      function addToCart(data) {      
        const cartEl = $(".cart-notification__products");
        cartEl.empty();
        cartEl.append(data.sections['section-cart-notification']);
  
        // update totals
        updateCartTotals();
      }
  
  
  
      // REMOVE FROM CART NOTIFICATION
      function removeFromCart(element) {     
        const cartEl = $(".cart-notification__products").find(".cart-notification__products__item");
  
        // mark this element as deleted, check if has associated elements
        let json = { 'line': $(element).attr("data-line"), 'quantity': 0 };      
        $(element).attr("data-line", "removed");
        // check if its a master product
        const mlink = $(element).attr("data-mlink");
        if (mlink) {
          // look for linked products to this and remove them also (gifts, accessories, ...)
          $(cartEl).find("[data-link='" + mlink + "'").each(function() {
            json.push({ 'line': $(this).attr("data-line"), 'quantity': 0 });
            $(this).attr("data-line", "removed");
          });
        }
  
        // renumber rest of lines
        let index = 1;
        $(cartEl).each(function () {
          if ($(this).attr("data-line") != "removed") {
            $(this).attr("data-line", index);
            index++;
          }
        });
  
        // make rest call to shopify
        $.post(window.Shopify.routes.root + "cart/change.js", json, null, "json")
          .done(function (data) {
            // remove deleted elements from cart notification
            $(cartEl).each(function() {
              if ($(this).attr("data-line") == "removed") $(this).fadeOut(250, function() {
                  $(this).remove();
                  // if cart notification is empty, auto close it
                  if ($(".cart-notification__products__item").length == 0) {
                    $(".cart-notification").removeClass("cart-notification-active");
                  }
                });
            });
            updateCartTotals();
  
          })
          .fail(function (data) {          
            // something gone wrong, ask for entire cart
            $.get(window.Shopify.routes.root + "?sections=section-cart-notification", "", function (data) {
              console.log(data);
              const cartEl = $(".cart-notification__products");
              cartEl.empty();
              cartEl.append(data['section-cart-notification']);
  
              // update totals
              updateCartTotals();
            }, "json");
          })
          .always(function (data) {
          });
      }
  
      // UPDATE CART TOTALS NOTIFICATION
      function updateCartTotals() {
        const cartEl = $(".cart-notification__products").find(".cart-notification__products__item");
  
        let totalQty = 0;
        let totalAmount = 0;
        $(cartEl).each(function (index) {
          const line = $(this).attr("data-line");
          if (line == "removed") return;
  
          const qtyEl = $(this).find(".cart-notification__products__item__quantity");
          let qty = 1;
          if (qtyEl) qty = +$(qtyEl).val();
          const prevQty = +$(qtyEl).attr("data-qty");
  
          totalQty += qty;
          totalAmount += qty * +$(this).find(".cart-notification__products__item__price").attr("data-price");
  
          // handle quantity less button (don't let go below 1)
          $(qtyEl).on("input", function(e) {
            if (+$(e.target).val() < 1) {
              $(e.target).val(1);
              e.preventDefault();
              e.stopPropagation();
            }
          });
  
          // handle quantity change
          const params = { "line": line };
          $(qtyEl).on("change", params, function (e) {
  
            // update quantity api call
            let json = { 'line': e.data['line'], 'quantity': +$(e.target).val() };
  
            // make rest call to shopify
            $.post(window.Shopify.routes.root + 'cart/change.js', json, null, "json")
              .done(function(data) {
                $(e.target).attr("data-qty", data['item_count']);
              })
              .fail(function(data) {
                // restore quantity to previous value
                $(e.target).val($(e.target).attr("data-qty"));
                // TODO: show not enough stock error?
              })
              .always(function(data) {
                updateCartTotals();
              });
          });
  
          // handle remove button click
          $(cartEl).find(".btn-remove").on("click", params, function (e) {
            // check it's not already removed
            let el = $(e.target).closest(".cart-notification__products__item");
            if ($(el).attr("data-line") != "removed") removeFromCart(el);
          });
        });
  
        // update total cart
        const totalEl = $(".cart-notification__bottom").find(".cart-notification__price");
        $(totalEl).html(formatMoney(totalAmount));
  
        // update also the num-cart total quantity
        $(".num-cart").html(totalQty);
      }
    }
  };
  
  if (typeof window === "undefined") {
    module.exports = {
      buildKlaviyoAddedToCartPayload,
      decodeCartErrorMessage,
      getCartAddErrorMessage
    };
  } else {
    CartNotification.init();
  }
